// PartyCade's own icons, drawn to match the site: chunky dark outlines,
// rounded corners and one bright color each. <Icon name="pen" /> is sized by
// the font size (1em) and takes its outline color from the text color.

const INK = "currentColor";
const BLUE = "#4dd4ff";
const PINK = "#ff6b9d";
const ORANGE = "#ffb84d";
const RED = "#ff4d6d";
const GREEN = "#3fcf74";
const PURPLE = "#b9a8ff";

const PATHS = {
  pen: (
    <>
      <path d="M4 20l1.2-4.6L15.3 5.3a2.2 2.2 0 0 1 3.1 0l.3.3a2.2 2.2 0 0 1 0 3.1L8.6 18.8Z" fill={ORANGE} />
      <path d="M4 20l1.2-4.6 3.4 3.4Z" fill="#fff" />
      <path d="M4 20l.5-1.9 1.4 1.4Z" fill={INK} />
      <path d="M13.4 7.2l3.4 3.4" />
    </>
  ),
  eraser: (
    <>
      <path d="M9.3 20.3 3.7 14.7a1.6 1.6 0 0 1 0-2.3l8.2-8.2a1.6 1.6 0 0 1 2.3 0l5.6 5.6a1.6 1.6 0 0 1 0 2.3l-8.2 8.2Z" fill="#fff" />
      <path d="m7.8 8.3 8 8 4-4a1.6 1.6 0 0 0 0-2.3l-5.6-5.6a1.6 1.6 0 0 0-2.3 0Z" fill={PINK} />
      <path d="M13 20.5h7.5" />
    </>
  ),
  fill: (
    <>
      <path d="M10.6 3.6 18.5 11.5 11.6 18.4a1.6 1.6 0 0 1-2.3 0L3.7 12.8a1.6 1.6 0 0 1 0-2.3Z" fill="#fff" />
      <path d="M3.3 11.6H18.4l-6.8 6.8a1.6 1.6 0 0 1-2.3 0L3.7 12.8a1.1 1.1 0 0 1-.4-1.2Z" fill={BLUE} stroke="none" />
      <path d="M10.6 3.6 18.5 11.5 11.6 18.4a1.6 1.6 0 0 1-2.3 0L3.7 12.8a1.6 1.6 0 0 1 0-2.3Z" />
      <path d="M7.2 7 4.6 4.4" />
      <path d="M20.2 14.6c-.9 1.5-1.8 2.5-1.8 3.5a1.8 1.8 0 0 0 3.6 0c0-1-.9-2-1.8-3.5Z" fill={BLUE} />
    </>
  ),
  picker: (
    <>
      <path d="M12.3 7.4l4.3 4.3-8.1 8.1a2 2 0 0 1-1.4.6H4.4v-2.7a2 2 0 0 1 .6-1.4Z" fill="#fff" />
      <path d="M4.4 20.4v-2.7a2 2 0 0 1 .6-1.4l3.1-3.1 4.3 4.3-3.1 3.1a2 2 0 0 1-1.4.6Z" fill={BLUE} stroke="none" />
      <path d="M12.3 7.4l4.3 4.3-8.1 8.1a2 2 0 0 1-1.4.6H4.4v-2.7a2 2 0 0 1 .6-1.4Z" />
      <path d="M10.9 6l7.1 7.1" />
      <path d="M14.1 8.8l2.9-2.9a2.3 2.3 0 0 1 3.2 3.2l-2.9 2.9Z" fill={PINK} />
    </>
  ),
  line: (
    <>
      <path d="M5.5 18.5 18.5 5.5" />
      <circle cx="5" cy="19" r="2.2" fill={GREEN} />
      <circle cx="19" cy="5" r="2.2" fill={GREEN} />
    </>
  ),
  rect: <rect x="3.5" y="5.5" width="17" height="13" rx="2.5" fill={BLUE} />,
  ellipse: <circle cx="12" cy="12" r="8.5" fill={ORANGE} />,
  undo: (
    <>
      <path d="M8.5 13.5 4 9l4.5-4.5" />
      <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H10" />
    </>
  ),
  redo: (
    <>
      <path d="M15.5 13.5 20 9l-4.5-4.5" />
      <path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H14" />
    </>
  ),
  trash: (
    <>
      <path d="M5.5 7.5l1 11.6a1.8 1.8 0 0 0 1.8 1.6h7.4a1.8 1.8 0 0 0 1.8-1.6l1-11.6Z" fill={RED} />
      <path d="M3.5 7.5h17" />
      <path d="M9 7.5V5.2A1.2 1.2 0 0 1 10.2 4h3.6A1.2 1.2 0 0 1 15 5.2v2.3" />
      <path d="M10 11.5v5M14 11.5v5" />
    </>
  ),
  // Party Tycoon spaces
  plane: (
    <path
      d="M12 2.8c.9 0 1.5.8 1.5 1.8v4.6l7 4.2v2l-7-2.1v4.1l2.2 1.6v1.8L12 20l-3.7.8V19l2.2-1.6v-4.1l-7 2.1v-2l7-4.2V4.6c0-1 .6-1.8 1.5-1.8Z"
      fill={BLUE}
    />
  ),
  factory: (
    <>
      <path d="M3.5 20.5V11l5 3v-3l5 3v-3l5 3V4.5h2.5v16Z" fill={ORANGE} />
      <path d="M7 17.5h2M11.5 17.5h2M16 17.5h2" />
    </>
  ),
  bolt: <path d="M13.5 2.5 5 13.5h6l-1.5 8 9-11.5h-6Z" fill="#ffd23f" />,
  drop: (
    <>
      <path d="M12 3c-3.5 4.6-6 7.9-6 11a6 6 0 0 0 12 0c0-3.1-2.5-6.4-6-11Z" fill={BLUE} />
      <path d="M9.5 14.5a2.6 2.6 0 0 0 2 2.4" />
    </>
  ),
  surprise: (
    <>
      <path d="M8.3 8.8a3.7 3.7 0 1 1 5.4 3.3c-1.1.6-1.7 1.3-1.7 2.5v.6" stroke={PINK} strokeWidth="3" />
      <circle cx="12" cy="19.6" r="1.7" fill={PINK} stroke="none" />
    </>
  ),
  coins: (
    <>
      <ellipse cx="12" cy="16.5" rx="7" ry="3" fill="#ffd23f" />
      <path d="M5 16.5v-3c0-1.7 3.1-3 7-3s7 1.3 7 3v3" fill="#ffd23f" />
      <ellipse cx="12" cy="13.5" rx="7" ry="3" fill="#ffe156" />
      <path d="M8 7.5c0-1.7 1.8-3 4-3s4 1.3 4 3-1.8 3-4 3-4-1.3-4-3Z" fill="#ffe156" />
    </>
  ),
  gem: (
    <>
      <path d="M7 4.5h10l4 5-9 10.5L3 9.5Z" fill="#7cd3ff" />
      <path d="M3 9.5h18M9 4.5l3 15.5 3-15.5" />
    </>
  ),
  start: (
    <>
      <path d="M5.5 21V3.5" />
      <path d="M5.5 4h13.5l-3 4 3 4H5.5Z" fill="#fff" />
      <path d="M9 4h3.5v4H16v4h-3.5V8H9Z M5.5 8H9v4H5.5Z" fill="currentColor" stroke="none" />
    </>
  ),
  jail: (
    <>
      <rect x="4" y="3.5" width="16" height="17" rx="2" fill="#c9c3b6" />
      <path d="M8.5 3.5v17M12 3.5v17M15.5 3.5v17" />
    </>
  ),
  palm: (
    <>
      <path d="M12.5 20c.3-4 0-8.5-1.5-11.5" />
      <path d="M11 8.5c-1.5-3-5-3.5-7.5-2 2.5.3 4.5 1.5 5.5 3.5-2.5-.5-5 .5-6 2.5 3-1.5 6-1.3 8-4Z" fill={GREEN} />
      <path d="M11 8.5c1-3 4.5-4.5 7.5-3.5-2.3.6-4 2-4.8 4 2.5-1 5.3-.3 6.8 1.6-3-1-6-.9-9.5-2.1Z" fill={GREEN} />
      <path d="M4 20.5h16" />
      <path d="M6 20.5c1-2 3-3 6-3s5 1 6 3Z" fill="#ffd23f" />
    </>
  ),
  siren: (
    <>
      <path d="M6.5 18v-5.5a5.5 5.5 0 0 1 11 0V18Z" fill={RED} />
      <rect x="4.5" y="18" width="15" height="3" rx="1" fill="#c9c3b6" />
      <path d="M12 2.5v2M4 5.5l1.5 1.5M20 5.5 18.5 7M9.5 12a2.5 2.5 0 0 1 2.5-2.5" />
    </>
  ),
  rocket: (
    <>
      <path d="M12 2.5c3.5 2.5 5 6 5 10.5l-2.5 3h-5L7 13c0-4.5 1.5-8 5-10.5Z" fill="#fff" />
      <path d="M7 13l-3 3.5V19l5-2.5M17 13l3 3.5V19l-5-2.5" fill={RED} />
      <circle cx="12" cy="9.5" r="2" fill={BLUE} />
      <path d="M10.5 19.5 12 22l1.5-2.5" stroke={ORANGE} />
    </>
  ),
  ufo: (
    <>
      <path d="M8 11a4 4 0 0 1 8 0" fill={BLUE} />
      <ellipse cx="12" cy="13" rx="9.5" ry="3.5" fill={PURPLE} />
      <path d="M7 16.5 5.5 19M17 16.5l1.5 2.5M12 16.5V20" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4.5" fill="#ffd23f" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
    </>
  ),
  moon: <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" fill={PURPLE} />,
  expand: (
    <>
      <rect x="8.5" y="8.5" width="7" height="7" rx="1.5" fill={PURPLE} />
      <path d="M4 9V5.5A1.5 1.5 0 0 1 5.5 4H9M15 4h3.5A1.5 1.5 0 0 1 20 5.5V9M20 15v3.5a1.5 1.5 0 0 1-1.5 1.5H15M9 20H5.5A1.5 1.5 0 0 1 4 18.5V15" />
    </>
  ),
};

export const ICONS = Object.keys(PATHS);

export default function Icon({ name, className = "" }) {
  return (
    <svg
      className={`icon ${className}`}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke={INK}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
